<template>
  <button v-tooltip="{ content: label, placement: tooltipPlacement, offset: 8, classes: 'tooltip--new' }" class="app-icon-button" :class="[`app-icon-button--${size}`, tone && `app-icon-button--${tone}`]" type="button" :aria-label="label" :disabled="disabled" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'AppIconButton',
  props: {
    label: { type: String, required: true },
    tooltipPlacement: { type: String, default: 'top' },
    disabled: Boolean,
    tone: { type: String, default: null, validator: value => value === null || ['amber', 'red'].includes(value) },
    size: { type: String, default: 'compact', validator: value => ['compact', 'normal'].includes(value) }
  }
}
</script>

<style lang="scss" scoped>
.app-icon-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid $ui-line-strong;
  border-radius: $ui-control-radius;
  background: $ui-surface;
  color: $ui-ink;
  cursor: pointer;

  &--normal { width: $ui-control-height; height: $ui-control-height; }
  &--amber { --ui-accent: #{$ui-amber}; --ui-accent-soft: #{$ui-amber-soft}; border-color: $ui-amber; background: $ui-amber-soft; color: $ui-amber; }
  &--red { --ui-accent: #{$ui-red}; --ui-accent-soft: #{$ui-red-soft}; border-color: $ui-red; background: $ui-red-soft; color: $ui-red; }
  &:hover:not(:disabled) { border-color: var(--ui-accent, #{$ui-blue}); background: var(--ui-accent-soft, #{$ui-blue-soft}); }
  &:focus-visible { outline: 2px solid var(--ui-accent, #{$ui-blue}); outline-offset: 2px; }
  &:disabled { opacity: .5; cursor: not-allowed; }
  :deep(img), :deep(svg) { width: 16px; height: 16px; }
  :deep(.pi) { font-size: 16px; line-height: 1; }
}
</style>
